const { client, loadToken } = require('./client');
export { loadToken };


export async function getEventReport(id, groups, options) {
    var { data } = await client.get(`/reports/event/${id}/${groups}`, options);
    return data;
}

export async function getLiveviewReport(uuid, start_time, options) {
    var { data } = await client.get(`/reports/device/${uuid}/${start_time}`, options);
    return data;
}

export async function getLiveviewHistoryReport(uuid, start_time, end_time, options) {
    var { data } = await client.get(`/reports/device/${uuid}/${start_time}/${end_time}`, options);
    return data;
}

const all = {
    loadToken, getEventReport, getLiveviewReport, getLiveviewHistoryReport
};

export default all;